import * as React from 'react'

import { styled } from '~/styled'

import { Text } from '../../text/Text'
import { useBannerContext } from '../BannerContext'

const StyledText = styled(
  Text,
  {
    base: ['text-(--banner-text-color)'],
    variants: {
      containerSize: {
        sm: ['mb-4'],
        md: ['mb-6']
      },
      hasDismiss: {
        true: []
      }
    },
    compoundVariants: [
      {
        containerSize: 'sm',
        hasDismiss: true,
        class: ['mr-10']
      }
    ]
  },
  {
    enabledResponsiveVariants: true
  }
)

export const BannerRegularText = (
  props: React.ComponentPropsWithoutRef<typeof Text>
) => {
  const { size, hasDismiss } = useBannerContext()

  return (
    <StyledText
      size={size}
      containerSize={size}
      hasDismiss={hasDismiss}
      {...props}
    />
  )
}

BannerRegularText.displayName = 'BannerRegularText'
